import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resources from './language/resource';

/**
 * Uncomment and comment line 30 "resources" for getting the resources from an API call.
 *
 * Example of JSON needed, since loadPath should send the language via queryString.
 * "{"download_app_title": "Download the Goalsetter app and start saving today!"}"
 *
 * import Backend from 'i18next-http-backend';
 *
 * const options = {
 *   loadPath: 'http://192.168.1.11:3001/Support/Test?lang={{lng}}',
 *   requestOptions: {
 *     mode: 'cors',
 *     credentials: 'same-origin',
 *     cache: 'default'
 *   }
 * }
 *
 * i18n.use(Backend).init({backend: options})
* */

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
